const API_ORIGIN = new URL(process.env.REACT_APP_BACKEND_URL).origin;

export const listenForMediaAuthentication = () => {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.addEventListener("message", event => {
    if (event.data?.type === "EVENT_MEDIA_AUTH" && event.ports[0]) {
      event.ports[0].postMessage({ token: localStorage.getItem("token"), apiOrigin: API_ORIGIN });
    }
  });
};

export const preparePrivateMedia = async () => {
  if (!("serviceWorker" in navigator)) throw new Error("Lecture en ligne indisponible dans ce navigateur. Le téléchargement reste disponible.");
  const registration = await navigator.serviceWorker.register("/sw.js");
  await registration.update();
  const pending = registration.installing || registration.waiting;
  if (pending && pending.state !== "activated") {
    await new Promise((resolve, reject) => {
      const timer = setTimeout(() => { pending.removeEventListener("statechange", check); reject(new Error("Le lecteur se prépare. Réessayez.")); }, 10000);
      const check = () => { if (pending.state === "activated") { clearTimeout(timer); pending.removeEventListener("statechange", check); resolve(); } };
      pending.addEventListener("statechange", check); check();
    });
  }
  await navigator.serviceWorker.ready;
  if (!navigator.serviceWorker.controller) {
    await new Promise((resolve, reject) => {
      const done = () => { clearTimeout(timer); navigator.serviceWorker.removeEventListener("controllerchange", done); resolve(); };
      const timer = setTimeout(() => { navigator.serviceWorker.removeEventListener("controllerchange", done); reject(new Error("Le lecteur se prépare. Réessayez.")); }, 10000);
      navigator.serviceWorker.addEventListener("controllerchange", done);
    });
  }
};